// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-wrapper[data-v-b375daba]{margin-left:auto;margin-right:auto;margin-top:var(--size-5);max-width:45rem}.back-link[data-v-b375daba]{align-items:center;display:flex;gap:var(--size-1)}.back-link svg[data-v-b375daba]{height:1em;width:1em}.section-content[data-v-b375daba]{margin-block:var(--size-7)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
